export const STATION_QUERY_KEY = {
  STATION: (userId: string) => ['station', userId],
  STATION_CHANNEL_ART: (userId: string) => ['station', userId, 'channel-art'],
  STATION_DETAIL: (userId: string) => ['station', userId, 'detail'],
  WITHDRAW: (userId: string) => ['withdraw', userId],
  EVENT_NOTICE: (streamerId: string) => ['eventNotice', streamerId],
  AUTHENTICATION: ['authentication'],
  STATION_INFO: (userId: string) => ['station', userId, 'info'],
  STATION_DASHBOARD: (userId: string) => ['station', userId, 'dashboard'],
};
